import ReactGA from 'react-ga4';

// https://raptis.wtf/blog/custom-hook-to-connect-google-analytics-in-react/

const TRACKING_ID = 'G-D99J3BVW4P';

function init() {
	// Enable debug mode on the local development environment
	const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

	console.log('isDev', isDev);
	ReactGA.initialize(TRACKING_ID, { debug: false });
}

function sendEvent(payload) {
	console.log('received value', payload);
	ReactGA.event(payload);
}

function sendPageview(path) {
	ReactGA.set({ page: path });
	ReactGA.send({ hitType: 'pageview', page: path });
}

export default {
	init,
	sendEvent,
	sendPageview,
};
